import { useEffect } from "react";
import { createPortal } from "react-dom";

const Portal = ({ children }) => {
  const portalElement = document.createElement("div");

  // Anexar ao final do body quando o componente montar
  useEffect(() => {
    document.body.appendChild(portalElement);
    return () => {
      document.body.removeChild(portalElement);
    };
  }, [portalElement]);

  return createPortal(children, portalElement);
};

export default Portal;
